import { useMemo } from "react";
import { Box, Text } from "@chakra-ui/react";

import { AddCardButton } from "../AddCard";
import { CardListInfo } from "./CardListInfo";
import { ElecsnetInfo } from "./ElecsnetInfo";
import { ToPaymentsButton } from "./ToPaymentsButton";
import { FilledCardListGroup } from "./FilledCardListGroup";
import { ICard } from "../../../../api/cards/types";
import { useSetMainProductMutation } from "../../../../api/cards";

interface Props {
  list: { cards: ICard[]; sbp: ICard[] };
}

export function FilledCardListView({ list }: Props) {
  const { mutateAsync, isPending, isError } = useSetMainProductMutation();

  const isLastLinkedCard: boolean = useMemo(() => {
    const linkedCards = list.cards.filter(c => c.statusCode === "LINKED");
    const linkedSbp = list.sbp.filter(s => s.statusCode === "LINKED");

    return linkedCards.length + linkedSbp.length === 1;
  }, [list]);

  const setMainProduct = async (cardId: string) => {
    try {
      await mutateAsync(cardId);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <CardListInfo />
      <Text variant="brand" fontSize="18px" mt="22px" mb="11px">Способы оплаты</Text>

      <ElecsnetInfo list={list} />
      <FilledCardListGroup
        title="Банковские карты"
        cards={list.cards}
        isLastLinkedCard={isLastLinkedCard}
        isProductStatusChanging={isPending}
        setMainProduct={setMainProduct}
      />
      <FilledCardListGroup
        title="CБП"
        cards={list.sbp}
        isLastLinkedCard={isLastLinkedCard}
        isProductStatusChanging={isPending}
        setMainProduct={setMainProduct}
      />

      {isError && (
        <Box mb="10px" fontSize="13px" lineHeight="18px">
          <Text variant="red">Не удалось изменить основной способ оплаты.</Text>
          <Text variant="red">Попробуйте ещё раз.</Text>
        </Box>
      )}

      <Box w="100%" mt="11px">
        <AddCardButton isProductStatusChanging={isPending} />
        <ToPaymentsButton isProductStatusChanging={isPending} />
      </Box>
    </>
  );
}
